// removed by extract-text-webpack-plugin
module.exports = {"container":"_3KP0I","name":"_2CQ9n"};


//////////////////
// WEBPACK FOOTER
// ./app/components/promote-user-details/promote-user-details.scss
// module id = 906
// module chunks = 3 4 5 6 7